import React, { useMemo } from 'react';
import EArchiveListWrapper from '../EArchiveListWrapper/EArchiveListWrapper';
import EArchiveGroupsListActions from './EArchiveGroupsListActions/EArchiveGroupsListActions';
import { GroupListContent } from '../../Enums/GroupListContent.enum';
import EArchiveGroupsList from './EArchiveGroupsList/EArchiveGroupsList';
import { useGroupsContext } from '../../Services/GroupsContext';
import EArchivePatientsListWrapper from '../EArchivePatientsListWrapper/EArchivePatientsListWrapper';

const EArchiveGroupsListWrapper = () => {
	const { groupListContent } = useGroupsContext();

	const contentComponent = useMemo(() => {
		switch (groupListContent) {
			case GroupListContent.GROUPS:
			case GroupListContent.GROUPS_DELETE:
				return <EArchiveGroupsList />;
			case GroupListContent.PATIENTS:
				return <EArchivePatientsListWrapper />;
			default:
				return <></>;
		}
	}, [groupListContent]);

	return (
		<EArchiveListWrapper>
			<EArchiveGroupsListActions />
			{contentComponent}
		</EArchiveListWrapper>
	);
};

export default EArchiveGroupsListWrapper;
